import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { registerUser } from '../../../redux/userRelated/userHandle';
import { useToast } from '../../../context/ToastContext';
import { underControl } from '../../../redux/userRelated/userSlice';
import { getAllSclasses } from '../../../redux/sclassRelated/sclassHandle';
import ParentChooser from '../../../components/ParentChooser';
import {
    CircularProgress, Box, Typography, Button,
    Grid, Paper, FormControlLabel, Switch,
    Card, CardContent, Avatar, Divider, Alert,
    IconButton, Container, TextField, InputAdornment
} from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import PersonIcon from '@mui/icons-material/Person';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import LinkIcon from '@mui/icons-material/Link';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import styled, { keyframes } from 'styled-components';
import BadgeIcon from '@mui/icons-material/Badge';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import HomeIcon from '@mui/icons-material/Home';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import SaveIcon from '@mui/icons-material/Save';
import MoneyIcon from '@mui/icons-material/AttachMoney';
import DeleteIcon from '@mui/icons-material/Delete';
import axios from 'axios';


const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

const AddStudent = ({ situation }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const params = useParams()

    const userState = useSelector(state => state.user);
    const { status, currentUser, response, error } = userState;
    const { sclassesList } = useSelector((state) => state.sclass);

    const [name, setName] = useState('');
    const [rollNum, setRollNum] = useState('');
    const [password, setPassword] = useState('')
    const [className, setClassName] = useState('')
    const [sclassName, setSclassName] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')
    const [address, setAddress] = useState('')
    const [dob, setDob] = useState('')
    const [photo, setPhoto] = useState(null)
    const [photoPreview, setPhotoPreview] = useState(null)

    // Student fee overrides (map: Others -> extras)
    const [tuitionFee, setTuitionFee] = useState('');
    const [admissionFee, setAdmissionFee] = useState('');
    const [annualFee, setAnnualFee] = useState('');
    const [computerFee, setComputerFee] = useState('');
    const [otherFees, setOtherFees] = useState('');


    const [linkToParent, setLinkToParent] = useState(false);
    const [selectedParent, setSelectedParent] = useState(null);
    const [parentChooserOpen, setParentChooserOpen] = useState(false);

    // Inline Parent States
    const [showInlineParentForm, setShowInlineParentForm] = useState(false);
    const [fatherName, setFatherName] = useState('');
    const [fatherOccupation, setFatherOccupation] = useState('');
    const [fatherPhone, setFatherPhone] = useState('');
    const [fatherEmail, setFatherEmail] = useState('');
    const [motherName, setMotherName] = useState('');
    const [motherOccupation, setMotherOccupation] = useState('');
    const [motherPhone, setMotherPhone] = useState('');
    const [motherEmail, setMotherEmail] = useState('');
    const [guardianName, setGuardianName] = useState('');
    const [guardianRelation, setGuardianRelation] = useState('');
    const [guardianPhone, setGuardianPhone] = useState('');
    const [guardianEmail, setGuardianEmail] = useState('');
    const [guardianAddress, setGuardianAddress] = useState('');
    const [parentEmail, setParentEmail] = useState('');
    const [parentPassword, setParentPassword] = useState('');
    const [parentPhone, setParentPhone] = useState('');
    const [parentAddress, setParentAddress] = useState('');
    const [parentPhoto, setParentPhoto] = useState(null);
    const [parentPhotoPreview, setParentPhotoPreview] = useState(null);

    const handleParentPhotoChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setParentPhoto(file);
            const reader = new FileReader();
            reader.onloadend = () => {
                setParentPhotoPreview(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const removeParentPhoto = () => {
        setParentPhoto(null);
        setParentPhotoPreview(null);
    };

    const adminID = currentUser._id
    const role = "Student"
    const attendance = []

    useEffect(() => {
        if (situation === "Class") {
            setSclassName(params.id);
            const selectedClass = sclassesList.find(c => c._id === params.id);
            if (selectedClass) setClassName(selectedClass.sclassName);
        }
    }, [params.id, situation, sclassesList]);

    const { showToast } = useToast();
    const [loader, setLoader] = useState(false)

    useEffect(() => {
        dispatch(getAllSclasses(adminID, "Sclass"));
    }, [adminID, dispatch]);

    const changeHandler = (event) => {
        if (event.target.value === 'Select Class') {
            setClassName('Select Class');
            setSclassName('');
        } else {
            const selectedClass = sclassesList.find(
                (classItem) => classItem.sclassName === event.target.value
            );
            setClassName(selectedClass.sclassName);
            setSclassName(selectedClass._id);
        }
    }

    const handlePhotoChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setPhoto(file);
            const reader = new FileReader();
            reader.onloadend = () => {
                setPhotoPreview(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const removePhoto = () => {
        setPhoto(null);
        setPhotoPreview(null);
    };

    const handleParentSelect = (parent) => {
        setSelectedParent(parent);
    };

    const handleRemoveParent = () => {
        setSelectedParent(null);
    };

    const fields = photo 
        ? { 
            name, rollNum, password, sclassName, adminID, role, attendance, 
            photo, email, phone, address, dob,
            tuitionFee: tuitionFee === '' ? undefined : Number(tuitionFee),
            admissionFee: admissionFee === '' ? undefined : Number(admissionFee),
            annualFee: annualFee === '' ? undefined : Number(annualFee),
            computerFee: computerFee === '' ? undefined : Number(computerFee),
            otherFees: otherFees === '' ? undefined : Number(otherFees),
            ...(linkToParent && selectedParent ? { parent: selectedParent._id } : {})
          }
        : { 
            name, rollNum, password, sclassName, adminID, role, attendance, 
            email, phone, address, dob,
            tuitionFee: tuitionFee === '' ? undefined : Number(tuitionFee),
            admissionFee: admissionFee === '' ? undefined : Number(admissionFee),
            annualFee: annualFee === '' ? undefined : Number(annualFee),
            computerFee: computerFee === '' ? undefined : Number(computerFee),
            otherFees: otherFees === '' ? undefined : Number(otherFees),
            ...(linkToParent && selectedParent ? { parent: selectedParent._id } : {})
          };

    const submitHandler = async (event) => {
        event.preventDefault();
        if (sclassName === "") {
            showToast("Please select a classname", "warning");
            return;
        }

        setLoader(true);

        try {
            let finalFields = { ...fields };

            if (linkToParent && showInlineParentForm) {
                if (!fatherName) {
                    showToast("Father's Name is required for creating a parent", "warning");
                    setLoader(false);
                    return;
                }
                if (!parentPassword) {
                    showToast("Parent Account Password is required", "warning");
                    setLoader(false);
                    return;
                }

                let parentPhotoUrl = "";
                if (parentPhoto) {
                    const photoFormData = new FormData();
                    photoFormData.append('photo', parentPhoto);
                    const photoRes = await axios.post(
                        `${process.env.REACT_APP_BASE_URL}/ProfilePhotoUpload`,
                        photoFormData,
                        { headers: { 'Content-Type': 'multipart/form-data' } }
                    );
                    parentPhotoUrl = photoRes.data.photo;
                }

                const parentPayload = {
                    fatherName, fatherOccupation, fatherPhone, fatherEmail,
                    motherName, motherOccupation, motherPhone, motherEmail,
                    guardianName, guardianRelation, guardianPhone, guardianEmail, guardianAddress,
                    school: adminID,
                    address: parentAddress,
                    phone: parentPhone,
                    email: parentEmail,
                    password: parentPassword,
                    role: "Parent"
                };
                if (parentPhotoUrl) {
                    parentPayload.photo = parentPhotoUrl;
                }

                const parentRes = await axios.post(
                    `${process.env.REACT_APP_BASE_URL}/ParentReg`,
                    parentPayload,
                    { headers: { 'Content-Type': 'application/json' } }
                );

                if (parentRes.data.message) {
                    showToast(parentRes.data.message, "error");
                    setLoader(false);
                    return;
                }

                const newParentId = parentRes.data._id;
                if (!newParentId) {
                    showToast("Failed to create parent account", "error");
                    setLoader(false);
                    return;
                }

                finalFields = {
                    ...finalFields,
                    parent: newParentId
                };
            }

            dispatch(registerUser(finalFields, role));
        } catch (error) {
            console.error("Error registering student or parent:", error);
            const errMsg = error.response?.data?.message || error.message || "Registration failed";
            showToast(errMsg, "error");
            setLoader(false);
        }
    };

    useEffect(() => {
        if (status === 'added') {
            dispatch(underControl())
            showToast("Student added successfully!", "success")
            setLoader(false)
            setTimeout(() => {
                navigate(-1)
            }, 1500)
        }
        else if (status === 'failed') {
            showToast(response, "error")
            setLoader(false)
        }
        else if (status === 'error') {
            showToast("Network Error", "error")
            setLoader(false)
        }
    }, [status, navigate, error, response, dispatch]);

    return (
        <StyledPageContainer>
            <StyledContainer maxWidth="md">
                <StyledPaper elevation={3}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 3, gap: 2 }}>
                        <IconButton onClick={() => navigate(-1)} sx={{ bgcolor: '#f5f5f5' }}>
                            <ArrowBackIcon />
                        </IconButton>
                        <Box>
                            <Typography variant="h4" sx={{ fontWeight: 700, color: '#1a1a2e' }}>
                                Add New Student 🎓
                            </Typography>
                            <Typography variant="body2" color="textSecondary">
                                Enroll a new student into the school system
                            </Typography>
                        </Box>
                    </Box>

                    <Divider sx={{ mb: 4 }} />

                    <form onSubmit={submitHandler}>
                        <Grid container spacing={4}>
                            {/* Photo & Class Section */}
                            <Grid item xs={12} md={4}>
                                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3 }}>
                                    <AvatarWrapper>
                                        <Avatar
                                            src={photoPreview}
                                            sx={{ 
                                                width: 150, 
                                                height: 150, 
                                                bgcolor: '#f0f2f5',
                                                border: '4px solid white',
                                                boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                                            }}
                                        >
                                            {!photoPreview && <PersonIcon sx={{ fontSize: 60, color: '#667eea' }} />}
                                        </Avatar>
                                        {photoPreview && (
                                            <IconButton 
                                                onClick={removePhoto}
                                                sx={{ 
                                                    position: 'absolute', 
                                                    top: 0, 
                                                    right: 0, 
                                                    bgcolor: '#ff4d4d', 
                                                    color: 'white',
                                                    '&:hover': { bgcolor: '#ff3333' }
                                                }}
                                                size="small"
                                            >
                                                ×
                                            </IconButton>
                                        )}
                                    </AvatarWrapper>

                                    <Button
                                        component="label"
                                        variant="outlined"
                                        startIcon={<CloudUploadIcon />}
                                        sx={{ borderRadius: '10px', textTransform: 'none' }}
                                    >
                                        Upload Photo
                                        <input type="file" hidden accept="image/*" onChange={handlePhotoChange} />
                                    </Button>

                                    <Box sx={{ width: '100%', mt: 2 }}>
                                        <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 700 }}>Assignment</Typography>
                                        {situation === "Student" ? (
                                            <TextField
                                                select
                                                fullWidth
                                                label="Select Class"
                                                value={className}
                                                onChange={changeHandler}
                                                SelectProps={{ native: true }}
                                                required
                                            >
                                                <option value='Select Class'>Select Class</option>
                                                {sclassesList.map((classItem, index) => (
                                                    <option key={index} value={classItem.sclassName}>
                                                        {classItem.sclassName}
                                                    </option>
                                                ))}
                                            </TextField>
                                        ) : (
                                            <Box sx={{ p: 2, bgcolor: '#f8f9fa', borderRadius: 2, border: '1px solid #eee' }}>
                                                <Typography variant="body2" color="textSecondary">Enrolling in:</Typography>
                                                <Typography variant="h6" sx={{ fontWeight: 600 }}>Class {className || "Loading..."}</Typography>
                                            </Box>
                                        )}
                                    </Box>
                                </Box>
                            </Grid>

                            {/* Form Section */}
                            <Grid item xs={12} md={8}>
                                <Typography variant="h6" sx={{ mb: 2, fontWeight: 700 }}>Personal Information</Typography>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={8}>
                                        <TextField
                                            fullWidth
                                            label="Full Name"
                                            required
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start"><PersonIcon fontSize="small" /></InputAdornment>,
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <TextField
                                            fullWidth
                                            label="Roll No."
                                            type="number"
                                            required
                                            value={rollNum}
                                            onChange={(e) => setRollNum(e.target.value)}
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start"><BadgeIcon fontSize="small" /></InputAdornment>,
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            label="Password"
                                            type="password"
                                            required
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            autoComplete="new-password"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            label="Date of Birth"
                                            placeholder="YYYY-MM-DD"
                                            value={dob}
                                            onChange={(e) => setDob(e.target.value)}
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start"><CalendarMonthIcon fontSize="small" /></InputAdornment>,
                                            }}
                                        />
                                    </Grid>
                                </Grid>

                                <Typography variant="h6" sx={{ mb: 2, mt: 4, fontWeight: 700 }}>Contact Details</Typography>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            label="Email Address"
                                            type="email"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start"><EmailIcon fontSize="small" /></InputAdornment>,
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            label="Phone Number"
                                            type="tel"
                                            value={phone}
                                            onChange={(e) => setPhone(e.target.value)}
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start"><PhoneIcon fontSize="small" /></InputAdornment>,
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            label="Address"
                                            multiline
                                            rows={2}
                                            value={address}
                                            onChange={(e) => setAddress(e.target.value)}
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start"><HomeIcon fontSize="small" /></InputAdornment>,
                                            }}
                                        />
                                    </Grid>
                                </Grid>

                                <Box sx={{ mt: 4 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                                        <Typography variant="h6" sx={{ fontWeight: 700 }}>Student Fees (Overrides)</Typography>
                                    </Box>

                                    <Grid container spacing={2} sx={{ mb: 4 }}>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                fullWidth
                                                label="Tuition Fee"
                                                type="number"
                                                value={tuitionFee}
                                                onChange={(e) => setTuitionFee(e.target.value)}
                                                InputProps={{ startAdornment: <InputAdornment position="start">Rs.</InputAdornment> }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                fullWidth
                                                label="Admission Fee"
                                                type="number"
                                                value={admissionFee}
                                                onChange={(e) => setAdmissionFee(e.target.value)}
                                                InputProps={{ startAdornment: <InputAdornment position="start">Rs.</InputAdornment> }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                fullWidth
                                                label="Annual Fee"
                                                type="number"
                                                value={annualFee}
                                                onChange={(e) => setAnnualFee(e.target.value)}
                                                InputProps={{ startAdornment: <InputAdornment position="start">Rs.</InputAdornment> }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                fullWidth
                                                label="Computer Fee"
                                                type="number"
                                                value={computerFee}
                                                onChange={(e) => setComputerFee(e.target.value)}
                                                InputProps={{ startAdornment: <InputAdornment position="start">Rs.</InputAdornment> }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                fullWidth
                                                label="Others"
                                                type="number"
                                                value={otherFees}
                                                onChange={(e) => setOtherFees(e.target.value)}
                                                InputProps={{ startAdornment: <InputAdornment position="start">Rs.</InputAdornment> }}
                                            />
                                        </Grid>
                                    </Grid>

                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                                        <Typography variant="h6" sx={{ fontWeight: 700 }}>Parent / Guardian</Typography>

                                        <FormControlLabel
                                            control={<Switch checked={linkToParent} onChange={(e) => setLinkToParent(e.target.checked)} />}
                                            label="Link to Parent"
                                        />
                                    </Box>

                                    {linkToParent && (
                                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                            <ParentCard variant="outlined">
                                                {selectedParent ? (
                                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                                            <Avatar sx={{ bgcolor: '#667eea' }}><PersonIcon /></Avatar>
                                                            <Box>
                                                                <Typography variant="subtitle1" fontWeight={600}>{selectedParent.fatherName || 'Parent'}</Typography>
                                                                <Typography variant="caption" color="textSecondary">{selectedParent.phone || 'No phone'}</Typography>
                                                            </Box>
                                                        </Box>
                                                        <Button size="small" color="error" onClick={handleRemoveParent}>Remove</Button>
                                                    </Box>
                                                ) : (
                                                    <Box sx={{ display: 'flex', gap: 2, width: '100%', flexDirection: { xs: 'column', sm: 'row' } }}>
                                                        <Button 
                                                            fullWidth 
                                                            variant="outlined" 
                                                            startIcon={<LinkIcon />} 
                                                            onClick={() => {
                                                                setParentChooserOpen(true);
                                                                setShowInlineParentForm(false);
                                                            }}
                                                            sx={{ textTransform: 'none', borderRadius: '10px' }}
                                                        >
                                                            Select Parent / Guardian
                                                        </Button>
                                                        <Button 
                                                            fullWidth 
                                                            variant={showInlineParentForm ? "contained" : "outlined"}
                                                            startIcon={<PersonAddIcon />} 
                                                            onClick={() => setShowInlineParentForm(!showInlineParentForm)}
                                                            sx={{ textTransform: 'none', borderRadius: '10px' }}
                                                        >
                                                            {showInlineParentForm ? "Hide Parent Form" : "Create Parent Inline"}
                                                        </Button>
                                                    </Box>
                                                )}
                                            </ParentCard>
                                        </Box>
                                    )}
                                </Box>
                            </Grid>
                        </Grid>

                        {/* ── Full-width inline parent form ── */}
                        {linkToParent && showInlineParentForm && !selectedParent && (
                            <Box sx={{ mt: 4, p: { xs: 2, sm: 4 }, border: '2px solid #e2e8f0', borderRadius: '20px', bgcolor: '#f8fafc' }}>
                                <Typography variant="h6" sx={{ fontWeight: 700, mb: 1, color: '#1a1a2e' }}>
                                    Create Parent / Guardian 👥
                                </Typography>
                                <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
                                    Fill in the details below to create a new parent account linked to this student.
                                </Typography>
                                <Divider sx={{ mb: 3 }} />

                                {/* Father's Details */}
                                <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#667eea', mb: 2 }}>Father's Details</Typography>
                                <Grid container spacing={3} sx={{ mb: 4 }}>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <TextField fullWidth label="Father's Name *" value={fatherName} onChange={e => setFatherName(e.target.value)} required={showInlineParentForm} />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <TextField fullWidth label="Father's Occupation" value={fatherOccupation} onChange={e => setFatherOccupation(e.target.value)} />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <TextField fullWidth label="Father's Phone" value={fatherPhone} onChange={e => setFatherPhone(e.target.value)} />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <TextField fullWidth label="Father's Email" type="email" value={fatherEmail} onChange={e => setFatherEmail(e.target.value)} />
                                    </Grid>
                                </Grid>

                                <Divider sx={{ mb: 3 }} />

                                {/* Mother's Details */}
                                <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#667eea', mb: 2 }}>Mother's Details</Typography>
                                <Grid container spacing={3} sx={{ mb: 4 }}>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <TextField fullWidth label="Mother's Name" value={motherName} onChange={e => setMotherName(e.target.value)} />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <TextField fullWidth label="Mother's Occupation" value={motherOccupation} onChange={e => setMotherOccupation(e.target.value)} />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <TextField fullWidth label="Mother's Phone" value={motherPhone} onChange={e => setMotherPhone(e.target.value)} />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <TextField fullWidth label="Mother's Email" type="email" value={motherEmail} onChange={e => setMotherEmail(e.target.value)} />
                                    </Grid>
                                </Grid>

                                <Divider sx={{ mb: 3 }} />

                                {/* Guardian Details */}
                                <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#667eea', mb: 2 }}>Guardian Details <Typography component="span" variant="caption" color="textSecondary">(Optional)</Typography></Typography>
                                <Grid container spacing={3} sx={{ mb: 4 }}>
                                    <Grid item xs={12} sm={6} md={2}>
                                        <TextField fullWidth label="Guardian Name" value={guardianName} onChange={e => setGuardianName(e.target.value)} />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={2}>
                                        <TextField fullWidth label="Relation" value={guardianRelation} onChange={e => setGuardianRelation(e.target.value)} />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={2}>
                                        <TextField fullWidth label="Guardian Phone" value={guardianPhone} onChange={e => setGuardianPhone(e.target.value)} />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <TextField fullWidth label="Guardian Email" type="email" value={guardianEmail} onChange={e => setGuardianEmail(e.target.value)} />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <TextField fullWidth label="Guardian Address" value={guardianAddress} onChange={e => setGuardianAddress(e.target.value)} />
                                    </Grid>
                                </Grid>

                                <Divider sx={{ mb: 3 }} />

                                {/* Account & Primary Contact */}
                                <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#667eea', mb: 2 }}>Account Access & Primary Contact</Typography>
                                <Grid container spacing={3} sx={{ mb: 4 }}>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <TextField fullWidth label="Primary Email" type="email" value={parentEmail} onChange={e => setParentEmail(e.target.value)} />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <TextField fullWidth label="Account Password *" type="password" value={parentPassword} onChange={e => setParentPassword(e.target.value)} required={showInlineParentForm} helperText="Used for parent portal login" />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <TextField fullWidth label="Primary Phone" value={parentPhone} onChange={e => setParentPhone(e.target.value)} />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <TextField fullWidth label="Primary Address" value={parentAddress} onChange={e => setParentAddress(e.target.value)} />
                                    </Grid>
                                </Grid>

                                <Divider sx={{ mb: 3 }} />

                                {/* Photo */}
                                <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#667eea', mb: 2 }}>Parent Profile Photo</Typography>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 3, p: 3, border: '2px dashed #cbd5e1', borderRadius: '14px', bgcolor: 'white' }}>
                                    {!parentPhotoPreview ? (
                                        <Button component="label" variant="outlined" startIcon={<CloudUploadIcon />} sx={{ textTransform: 'none', borderRadius: '10px' }}>
                                            Upload Photo
                                            <input type="file" hidden accept="image/*" onChange={handleParentPhotoChange} />
                                        </Button>
                                    ) : (
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                            <Avatar src={parentPhotoPreview} sx={{ width: 72, height: 72, border: '3px solid #667eea' }} />
                                            <Box>
                                                <Typography variant="body2" fontWeight={600}>Photo selected</Typography>
                                                <Button variant="outlined" color="error" size="small" startIcon={<DeleteIcon />} onClick={removeParentPhoto} sx={{ mt: 0.5, textTransform: 'none' }}>
                                                    Remove
                                                </Button>
                                            </Box>
                                        </Box>
                                    )}
                                    <Typography variant="caption" color="textSecondary">JPG, PNG up to 10MB</Typography>
                                </Box>
                            </Box>
                        )}

                        <Box sx={{ mt: 5, display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                            <Button
                                variant="outlined"
                                onClick={() => navigate(-1)}
                                sx={{ borderRadius: '10px', px: 4, py: 1.2, fontWeight: 600, textTransform: 'none' }}
                            >
                                Cancel
                            </Button>
                            <Button 
                                variant="contained" 
                                type="submit" 
                                disabled={loader}
                                startIcon={loader ? <CircularProgress size={20} color="inherit" /> : <SaveIcon />}
                                sx={{ 
                                    borderRadius: '10px', px: 6, py: 1.2, fontWeight: 600, textTransform: 'none',
                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                    boxShadow: '0 4px 15px rgba(102, 126, 234, 0.3)'
                                }}
                            >
                                {loader ? 'Adding...' : 'Add Student'}
                            </Button>
                        </Box>
                    </form>
                </StyledPaper>
            </StyledContainer>

            <ParentChooser
                open={parentChooserOpen}
                onClose={() => setParentChooserOpen(false)}
                onSelect={handleParentSelect}
                onCreateNew={() => navigate("/Admin/addparent")}
                schoolId={adminID}
                title="Select Parent / Guardian"
                buttonText="Select Parent"
                selectedParent={selectedParent}
                showCreateNew={true}
            />
        </StyledPageContainer>
    );
}

export default AddStudent;

const StyledPageContainer = styled.div`
  background-color: #f8f9fa;
  min-height: 100vh;
  padding-top: 40px;
  padding-bottom: 40px;
`;

const StyledContainer = styled(Container)`
  animation: ${fadeIn} 0.6s ease-out;
`;

const StyledPaper = styled(Paper)`
  padding: 40px;
  border-radius: 24px !important;
  background-color: white !important;
  box-shadow: 0 10px 30px rgba(0,0,0,0.05) !important;
`;

const AvatarWrapper = styled(Box)`
  position: relative;
`;

const ParentCard = styled(Box)`
  padding: 16px;
  border-radius: 12px;
  background-color: #fcfcfd;
  border: 1px dashed #667eea;
  display: flex;
  align-items: center;
  justify-content: center;
`;
